import SparkMD5 from 'spark-md5'

export const md5 = (md5Target: string) => SparkMD5.hash(md5Target)
